import { IReportMediaOptions } from "../types/reportsInterfaces";
import { getPhotoOriginalUrl, getPhotoSceneLabel } from "./reportPhoto";

export const createItemsArray = (
  data: IReportMediaOptions[],
  titleKey?: string,
  useOriginal?: boolean,
  aiReview?: any,
  aiReviewSummary?: any
) => {
  return (data || []).map((elem: IReportMediaOptions) => {
    const scene = getPhotoSceneLabel(elem, aiReview, aiReviewSummary);
    const name = titleKey
      ? titleKey.split('.').reduce((acc: any, key: string) => acc?.[key], elem)
      : '';
    const title = scene ? `Сцена: ${scene}` : name;
    return {
      src: useOriginal
        ? getPhotoOriginalUrl(elem) || elem?.url?.link
        : elem?.url?.link,
      ...(title ? { title } : {}),
    };
  });
};